/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarePrincipalFinalizeSettingsEntity
 */
export interface CarePrincipalFinalizeSettingsEntity {
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalFinalizeSettingsEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalFinalizeSettingsEntity
     */
    cardType?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalFinalizeSettingsEntity
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalFinalizeSettingsEntity
     */
    cronPattern?: string;
    /**
     * 
     * @type {number}
     * @memberof CarePrincipalFinalizeSettingsEntity
     */
    hours?: number;
}

export function CarePrincipalFinalizeSettingsEntityFromJSON(json: any): CarePrincipalFinalizeSettingsEntity {
    return CarePrincipalFinalizeSettingsEntityFromJSONTyped(json, false);
}

export function CarePrincipalFinalizeSettingsEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarePrincipalFinalizeSettingsEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'cardType': !exists(json, 'cardType') ? undefined : json['cardType'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'cronPattern': !exists(json, 'cronPattern') ? undefined : json['cronPattern'],
        'hours': !exists(json, 'hours') ? undefined : json['hours'],
    };
}

export function CarePrincipalFinalizeSettingsEntityToJSON(value?: CarePrincipalFinalizeSettingsEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'cardType': value.cardType,
        'carePrincipalId': value.carePrincipalId,
        'cronPattern': value.cronPattern,
        'hours': value.hours,
    };
}

